import { render, staticRenderFns } from "./GuiaOutrasDespesas.vue?vue&type=template&id=882260a4&"
import script from "./GuiaOutrasDespesas.vue?vue&type=script&lang=js&"
export * from "./GuiaOutrasDespesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports